import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Facebook, Twitter, Linkedin } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-gray-300" data-id="element-21">
      <div className="container mx-auto px-4 md:px-6 py-12 md:py-16" data-id="element-22">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12" data-id="element-23">
          {/* Brand Info */}
          <div className="space-y-4" data-id="element-24">
            <div className="flex items-center gap-3" data-id="element-25">
              <img src="https://cdn.magicpatterns.com/uploads/stkewdFoDLsveAsLMC6296/favi__logo.png" alt="KMA UK Logo" className="h-12 w-12 object-contain" data-id="element-26" />
              <span className="text-xl font-serif font-bold text-white" data-id="element-27">
                KMA UK
              </span>
            </div>
            <p className="text-sm leading-relaxed text-gray-400" data-id="element-28">
              A professional network of doctors and healthcare professionals
              dedicated to medical excellence and humanitarian service.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-29">
            <h3 className="text-white font-serif font-semibold mb-4" data-id="element-30">
              Quick Links
            </h3>
            <ul className="space-y-2 text-sm" data-id="element-31">
              <li data-id="element-32">
                <Link to="/about" className="hover:text-primary-400 transition-colors" data-id="element-33">
                  About Us
                </Link>
              </li>
              <li data-id="element-34">
                <Link to="/membership" className="hover:text-primary-400 transition-colors" data-id="element-35">
                  Membership
                </Link>
              </li>
              <li data-id="element-36">
                <Link to="/events" className="hover:text-primary-400 transition-colors" data-id="element-37">
                  Events
                </Link>
              </li>
              <li data-id="element-38">
                <Link to="/charity" className="hover:text-primary-400 transition-colors" data-id="element-39">
                  Charity Work
                </Link>
              </li>
              <li data-id="element-40">
                <Link to="/team" className="hover:text-primary-400 transition-colors" data-id="element-41">
                  Our Team
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-42">
            <h3 className="text-white font-serif font-semibold mb-4" data-id="element-43">
              Contact Us
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-44">
              <li className="flex items-start space-x-3" data-id="element-45">
                <MapPin className="h-5 w-5 text-primary-500 shrink-0" data-id="element-46" />
                <span data-id="element-47">
                  17 Honeybourne,
                  <br data-id="element-48" />
                  Bishop's Stortford, CM23 4EF
                </span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-49">
                <Mail className="h-5 w-5 text-primary-500 shrink-0" data-id="element-50" />
                <a href="mailto:info@kmauk.org" className="hover:text-primary-400" data-id="element-51">
                  info@kmauk.org
                </a>
              </li>
            </ul>
          </div>

          {/* Legal & Social */}
          <div data-id="element-52">
            <h3 className="text-white font-serif font-semibold mb-4" data-id="element-53">
              Connect
            </h3>
            <div className="flex space-x-4 mb-6" data-id="element-54">
              <a href="#" className="p-2 bg-gray-800 rounded-full hover:bg-primary-600 transition-colors" aria-label="Facebook" data-id="element-55">
                <Facebook className="h-4 w-4" data-id="element-56" />
              </a>
              <a href="#" className="p-2 bg-gray-800 rounded-full hover:bg-primary-600 transition-colors" aria-label="Twitter" data-id="element-57">
                <Twitter className="h-4 w-4" data-id="element-58" />
              </a>
              <a href="#" className="p-2 bg-gray-800 rounded-full hover:bg-primary-600 transition-colors" aria-label="LinkedIn" data-id="element-59">
                <Linkedin className="h-4 w-4" data-id="element-60" />
              </a>
            </div>
            <div className="text-sm space-y-2" data-id="element-61">
              <Link to="/privacy" className="block hover:text-primary-400" data-id="element-62">
                Privacy Policy
              </Link>
              <Link to="/privacy" className="block hover:text-primary-400" data-id="element-63">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-sm text-gray-500" data-id="element-64">
          <p data-id="element-65">
            &copy; {currentYear} Khyber Medical Association UK. All rights
            reserved.
          </p>
          <p className="mt-2 text-xs" data-id="element-66">Registered Charity in England & Wales.</p>
        </div>
      </div>
    </footer>;
}